<template>
  <div class="base_setting">
    <div class="setting_item ">
      <div class="item_label">
        头像
      </div>

      <van-uploader :after-read="afterRead">
        <div class="avatar">
          <img
            v-if="accountData.avatarUrl"
            :src="accountData.avatarUrl"
            class="avatar_img"
          />
          <img v-else src="@/assets/icon／用户.png" class="avatar_img" />
          <van-icon name="arrow" class="edit_icon" />
        </div>
      </van-uploader>
    </div>
    <div class="setting_item">
      <div class="item_label">
        昵称
      </div>
      <div class="value">
        {{ userInfo.username }}
      </div>
    </div>
    <div class="setting_item2">
      <div class="item_label">
        账号ID
      </div>
      <div class="value">
        {{ userInfo.id }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  sipUser,
  accountGet,
  filePreUpload,
  uploadOSS,
  accountUpdate
} from '@/api';
import { formatDate, uuid } from '@/utils/util';
export default {
  data() {
    return {
      userInfo: {},
      accountData: {},
      avatarUrl: ''
    };
  },
  mounted() {
    this.getUserInfo();
    this.getAccount();
  },
  methods: {
    getUserInfo() {
      sipUser().then((res) => {
        if (res.success) {
          this.userInfo = res.data;
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    getAccount() {
      accountGet().then((res) => {
        this.accountData = res.data;
      });
    },
    afterRead(fileData) {
      filePreUpload().then((res) => {
        const data = res.data;
        const url = data.url;
        const prefix = data.key;
        delete data.url;
        delete data.key;
        const array = fileData.file.name.replace(' ', '').split('.'); // 把文件名数组化
        let suffix = ''; // 后缀
        if (array.length > 1) {
          suffix = `.${array.pop().toLowerCase()}`;
        }
        const formData = new FormData();
        Object.keys(data).forEach((it) => {
          formData.append(it, data[it]);
        });
        const key = `${prefix}/${uuid()}${suffix}`; // 图片访问路径
        formData.append('key', key);
        formData.append('file', fileData.file);
        uploadOSS(url, formData).then((res2) => {
          // 上传成功，设置图片访问路径
          let avatarUrl = 'http://cache.czkj.cn/' + key;
          accountUpdate({
            avatarUrl
          })
            .then((res3) => {
              if (res3.success) {
                this.$toast.success('修改成功');
                this.getAccount();
              } else {
                this.$toast.fail(res3.msg);
              }
            })
            .catch((err) => {
              return this.$toast.fail(err);
            });
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.base_setting {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-top: 3.2vw;
  .setting_item {
    padding: 4.267vw;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item_label {
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.85);
    }
    .value {
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.45);
    }

    .avatar {
      display: flex;
      align-items: center;

      .avatar_img {
        width: 10.667vw;
        height: 10.667vw;
        border-radius: 50%;
      }
      .edit_icon {
        margin-left: 2.133vw;
        color: #aaacb1;
      }
    }
  }
  .setting_item2 {
    margin-top: 3.2vw;
    padding: 4.267vw;
    background: #ffffff;
    .item_label {
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 2.133vw;
    }
    .value {
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.25);
    }
  }
}
</style>
